import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'chart-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  template: `
    <div class="flex flex-col gap-y-1">
      <span class="font-medium text-lg leading-none">
        {{ title() }}
      </span>
      <span class="text-xs text-neutral-7 leading-none">
        {{ subtitle() }}
      </span>
    </div>
  `,
})
export class ChartHeader {
  title = input<string>();
  subtitle = input<string>();
}
